import { render, staticRenderFns } from "./fabButton.vue?vue&type=template&id=2c00de04&scoped=true"
import script from "./fabButton.vue?vue&type=script&lang=js"
export * from "./fabButton.vue?vue&type=script&lang=js"
import style0 from "./fabButton.vue?vue&type=style&index=0&id=2c00de04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00de04",
  null
  
)

export default component.exports